/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createTestIntegrationResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type TestIntegrationResponse } from '../../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/{organizationId}/integrations/{integrationId}/test
 */
export interface TestRequestBuilder extends BaseRequestBuilder<TestRequestBuilder> {
    /**
     * Calls the provider with the stored credentials to find out whether the integration actually works. Neither creating nor updating an integration verifies anything, so this is how a wrong credential is found before a customer hits it — worth calling right after either, and whenever a response reports testConnectionRequired. A failed test is still a 200: read isSuccessful, not the status code. Only the connection is exercised; nothing is written at the provider and no data is exchanged, so the call is safe to repeat. The outcome is recorded against the integration and reads back as testStatus and lastTestedAt on the list endpoint.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<TestIntegrationResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<TestIntegrationResponse | undefined>;
    /**
     * Calls the provider with the stored credentials to find out whether the integration actually works. Neither creating nor updating an integration verifies anything, so this is how a wrong credential is found before a customer hits it — worth calling right after either, and whenever a response reports testConnectionRequired. A failed test is still a 200: read isSuccessful, not the status code. Only the connection is exercised; nothing is written at the provider and no data is exchanged, so the call is safe to repeat. The outcome is recorded against the integration and reads back as testStatus and lastTestedAt on the list endpoint.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const TestRequestBuilderUriTemplate = "{+baseurl}/api/organizations/{organizationId}/integrations/{integrationId}/test";
/**
 * Metadata for all the requests in the request builder.
 */
export const TestRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: TestRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createTestIntegrationResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
